import dayjs, { Dayjs } from 'dayjs';
import faker from 'faker';

import { DateRange } from '../types';

export function pickDateInRange(dateRange: DateRange): Dayjs {
  return dayjs(faker.date.between(dateRange.start.toDate(), dateRange.end.toDate()));
}
